/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Action { 
    actionLabel: string;
    goToStep?: number;
    goToNextStep?: number;
    goToSwimlane?: Array<string>;
    goToConditionalNextStep?: number;
    checkPreviousStep?: boolean;
    showAssetToApprover?: boolean;
    actionTypePosition?: string;
    actionType?: string;
    assetPublication?: boolean;
    reusableAction?: boolean;
    saveAsVersion?: boolean;
    removeAssignee?: boolean;
    publishNextStep?: number;
    actionColor?: string;
    actionClass?: string;
    url?: string;
    icon?: string;
    alignIcon?: string;
    disable?: boolean;
    clearAnnotation?: boolean;
    rejectionFlag?: boolean;
    visible?: boolean;
}

